import { FC } from "react";
import { InvestigationFile, ProsecutorDecisionFeedback } from "types";
import { DateView } from "utils/helper";

type Props = {
  file: InvestigationFile;
};

const ProsecutorFeedbackView: FC<Props> = ({ file }) => {
  return (
    <div>
      <div className="bg-white shadow-md rounded-lg p-6  ">
        <div className="flex items-center mt-4 w-[678px]">
          <p className="text-[#9D0303] font-[Poppins] font-[600] text-lg ">
            Feedback
          </p>
        </div>

        <div className={"block"}>
          {file?.prosecutor_feedbacks &&
            file?.prosecutor_feedbacks.length === 0 && (
              <div>
                <p className="p-4 text-center text-gray-500">
                  No feedback found.
                </p>
              </div>
            )}
          {file?.prosecutor_feedbacks &&
            file?.prosecutor_feedbacks
              ?.reverse()
              ?.map((feedback: ProsecutorDecisionFeedback, index: number) => (
                <div key={index} className="mt-4">
                  <div className="flex flex-col border border-[#E6E6E6] p-4 rounded-lg bg-white shadow-sm">
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex items-center gap-3">
                        <div>
                          <div className="text-xs text-gray-400">
                            {DateView(
                              feedback?.created_at ?? feedback?.created_at
                            ) ?? "-"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <p className="mt-3 text-sm text-gray-700 whitespace-pre-wrap">
                      {feedback?.feedback_text ??
                        feedback?.feedback_text ??
                        "-"}
                    </p>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default ProsecutorFeedbackView;
